// Futurense branding colors
export const colors = {
  darkPurple: '#251A3E',  // Very Dark Purple / Navy
  almostBlack: '#0D0D0F', // Almost Black
  softPurple: '#7C5CC1',  // Soft Purple / Lavender
  charcoal: '#181818',    // Dark Charcoal Gray
  mediumGray: '#515151',  // Medium Gray
  mutedGray: '#94949D',   // Muted Gray with a hint of Blue
};

// Theme variants for buttons and UI elements
export const variants = {
  primary: {
    background: colors.softPurple,
    color: 'white',
    hoverBackground: '#8A5FF0', // Slightly darker purple
    activeBackground: '#7A4FE0', // Even darker purple
  },
  secondary: {
    background: colors.mutedGray,
    color: 'white',
    hoverBackground: '#85858E', // Slightly darker gray
    activeBackground: '#76767F', // Even darker gray
  },
  outline: {
    background: 'transparent',
    color: colors.darkPurple,
    border: `1px solid ${colors.darkPurple}`,
    hoverBackground: 'rgba(37, 26, 62, 0.05)', // Very light purple
    activeBackground: 'rgba(37, 26, 62, 0.1)', // Slightly darker light purple
  },
};

// Status colors
export const statusColors = {
  completed: {
    text: '#4CAF50', // Green
    background: '#E8F5E9', // Light green
  },
  pending: {
    text: colors.softPurple,
    background: 'rgba(159, 118, 249, 0.1)', // Very light purple
  },
  inactive: {
    text: colors.mutedGray,
    background: '#F5F5F5', // Light gray
  },
};

export default {
  colors,
  variants,
  statusColors,
};
